export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["ACSS_DEBIT"] = "ACSS_DEBIT";
    PaymentMethodType["AFFIRM"] = "AFFIRM";
    PaymentMethodType["AFTERPAY_CLEARPAY"] = "AFTERPAY_CLEARPAY";
    PaymentMethodType["ALIPAY"] = "ALIPAY";
    PaymentMethodType["AMAZON_PAY"] = "AMAZON_PAY";
    PaymentMethodType["AU_BECS_DEBIT"] = "AU_BECS_DEBIT";
    PaymentMethodType["BACS_DEBIT"] = "BACS_DEBIT";
    PaymentMethodType["BANCONTACT"] = "BANCONTACT";
    PaymentMethodType["BLIK"] = "BLIK";
    PaymentMethodType["BOLETO"] = "BOLETO";
    PaymentMethodType["CARD"] = "CARD";
    PaymentMethodType["CARD_PRESENT"] = "CARD_PRESENT";
    PaymentMethodType["CASHAPP"] = "CASHAPP";
    PaymentMethodType["CUSTOMER_BALANCE"] = "CUSTOMER_BALANCE";
    PaymentMethodType["EPS"] = "EPS";
    PaymentMethodType["FPX"] = "FPX";
    PaymentMethodType["GIROPAY"] = "GIROPAY";
    PaymentMethodType["GRABPAY"] = "GRABPAY";
    PaymentMethodType["IDEAL"] = "IDEAL";
    PaymentMethodType["INTERAC_PRESENT"] = "INTERAC_PRESENT";
    PaymentMethodType["KLARNA"] = "KLARNA";
    PaymentMethodType["KONBINI"] = "KONBINI";
    PaymentMethodType["LINK"] = "LINK";
    PaymentMethodType["MOBILEPAY"] = "MOBILEPAY";
    PaymentMethodType["MULTIBANCO"] = "MULTIBANCO";
    PaymentMethodType["OXXO"] = "OXXO";
    PaymentMethodType["P24"] = "P24";
    PaymentMethodType["PAYNOW"] = "PAYNOW";
    PaymentMethodType["PAYPAL"] = "PAYPAL";
    PaymentMethodType["PIX"] = "PIX";
    PaymentMethodType["PROMPTPAY"] = "PROMPTPAY";
    PaymentMethodType["REVOLUT_PAY"] = "REVOLUT_PAY";
    PaymentMethodType["SEPA_DEBIT"] = "SEPA_DEBIT";
    PaymentMethodType["SOFORT"] = "SOFORT";
    PaymentMethodType["SWISH"] = "SWISH";
    PaymentMethodType["TWINT"] = "TWINT";
    PaymentMethodType["US_BANK_ACCOUNT"] = "US_BANK_ACCOUNT";
    PaymentMethodType["WECHAT_PAY"] = "WECHAT_PAY";
    PaymentMethodType["ZIP"] = "ZIP";
})(PaymentMethodType || (PaymentMethodType = {}));
